module.exports = __webpack_public_path__ + "img/Moon.7c78c273.svg";